module.exports = __webpack_public_path__ + "img/so.cbb4d7ef.png";